import {Outlet, useSearchParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {Box, Grid, useTheme} from "@mui/material";
import Header from "../component/Header";
import CustomSnackbar from "../component/CustomSnackbar";
import CircularProgressSvg from "../component/CircularProgressSvg";
import {useCookies} from "react-cookie";

const ExternalHomePage = () => {
    const [searchParams] = useSearchParams();
    const [cookies, setCookie] = useCookies(['code', 'username']);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setCookie("code", searchParams.get("code"), {path: "/"});
        setCookie("username", searchParams.get("username"), {path: "/"});
    }, []);

    useEffect(() => {
        if (cookies.code && cookies.username) {
            setIsLoading(false);
        }
    }, [cookies]);

    return (
        <Box className={'homepage'}>
            <Grid container>
                <Grid item xs={12}>
                    <Header isExternal={true} menuIsOpen={false} setMenuIsOpen={null}/>
                </Grid>
                <Grid item xs>
                    <Box pt={useTheme().spacing(6)}>
                        {!isLoading && <Outlet/>}
                    </Box>
                </Grid>
            </Grid>
            <CustomSnackbar/>
            <CircularProgressSvg/>
        </Box>
    );
}

export default ExternalHomePage;
